import service from '@/utils/request'

export function getWebViewConfig(config = {}) {
    return service.get('/api/v1/webViewConfig/', config)
}

export function getActivityControls(config = {}) {
    return service.get('/api/v1/activity-controls/', config)
}

export function getNotification(config = {}) {
    return service.get('/api/v1/notification/', config)
}

export function markAppDownloadLog() {
    return service.get('/api/v1/app-download-log/')
}

/** 首页责任人 / 监督人 / 担保企业（公开） */
export function getHomePersonnel(config = {}) {
    return service.get('/api/v1/home-personnel/', config)
}

/** 责任人二级页简介（公开） */
export function getHomePersonnelDetail(id, config = {}) {
    return service.get(`/api/v1/home-personnel/${id}/`, config)
}
